import { useEffect, useState } from "react";
import { BrowserStorage, useUserConsents } from "@jti/rest-api";
import { useAemModel } from "../../contexts";
const isExpiringSoon = (consent, consentExpirationLimit) => {
    const DAY_IN_MS = 1000 * 3600 * 24;
    if (!consent?.expirationDate)
        return false;
    const now = new Date();
    const expirationDate = new Date(consent.expirationDate);
    const diffInDays = Math.floor((expirationDate.getTime() - now.getTime()) / DAY_IN_MS);
    return diffInDays < consentExpirationLimit;
};
export const useConsentPopUp = () => {
    const DAY_IN_MS = 1000 * 3600 * 24;
    const { consentReminderPopup } = useAemModel();
    const { maximumOccurancesPerYear = 0, consentExpirationLimit = 0, popUpDelay = 0, offerConsentName, productInformationConsentName, ploomClubConsentName, consentReminderPopupEnabled, } = consentReminderPopup || {};
    const millisecondsDelay = popUpDelay * 1000 || 0;
    const [shouldConsentPopUpBeVisible, setShouldConsentPopUpBeVisible] = useState(false);
    const [consentType, setConsentType] = useState(null);
    const [isConsentPopupOpen, setIsConsentPopupOpen] = useState(true);
    const browserStorage = new BrowserStorage();
    const consentData = browserStorage.get("consentData", { popUpShownDates: [] });
    const popUpShownDates = consentData.popUpShownDates.map((date) => new Date(date));
    const currentDate = new Date();
    const lastYearShowUps = popUpShownDates.filter((date) => {
        const diffInDays = Math.floor((currentDate.getTime() - date.getTime()) / DAY_IN_MS);
        return diffInDays < 365;
    });
    const numberOfShowUpsLastYear = lastYearShowUps.length;
    const { data, isLoading, isError } = useUserConsents("all");
    const closeConsentsPopUp = () => {
        setIsConsentPopupOpen(false);
    };
    useEffect(() => {
        if (!consentReminderPopupEnabled ||
            numberOfShowUpsLastYear >= maximumOccurancesPerYear ||
            isLoading ||
            isError ||
            shouldConsentPopUpBeVisible) {
            return;
        }
        const timerId = setTimeout(() => {
            if (data) {
                const offerConsent = data.find((consent) => consent.name === offerConsentName);
                const productConsent = data.find((consent) => consent.name === productInformationConsentName);
                const ploomClubConsent = data.find((consent) => consent.name === ploomClubConsentName);
                let popupType = null;
                if (offerConsent && !offerConsent.oneOff && isExpiringSoon(offerConsent, consentExpirationLimit)) {
                    popupType = "offer_consent";
                }
                else if (productConsent && !productConsent.oneOff && isExpiringSoon(productConsent, consentExpirationLimit)) {
                    popupType = "product_consent";
                }
                else if (ploomClubConsent && !ploomClubConsent.accepted) {
                    popupType = "ploom_club_consent";
                }
                if (popupType) {
                    setConsentType(popupType);
                    setShouldConsentPopUpBeVisible(true);
                    browserStorage.set("consentData", {
                        popUpShownDates: [...popUpShownDates, new Date()],
                    });
                }
            }
        }, millisecondsDelay);
        return () => {
            clearTimeout(timerId);
        };
    }, [data, isLoading, isError, numberOfShowUpsLastYear, millisecondsDelay, consentReminderPopupEnabled]);
    return {
        isConsentPopUpVisible: shouldConsentPopUpBeVisible && isConsentPopupOpen,
        consentType,
        closeConsentsPopUp,
    };
};
//# sourceMappingURL=useConsentPopUp.js.map